import { Box, Link, Text } from '@chakra-ui/react';
import COLORS from 'constants/colors';
import { useState } from 'react';

const PANDADOC_FORM_URL =
  'https://eform.pandadoc.com/?eform=5ae933c5-1fc4-4ac4-b58c-139eb4a08067';

export const IsolvedInstructionsAugmentation = () => {
  const [didFailToLoad, setDidFailToLoad] = useState(false);

  return (
    <Box
      data-testid="isolved-instructions-augmentation"
      w="full"
      mt="24px"
      mb="24px"
      p="20px"
      borderRadius="16px"
      border={`1px dashed ${COLORS.FINCH.LIGHT_GRAY}`}
      bg={COLORS.WHITE}
    >
      <Text fontSize="14px" fontWeight="600" color={COLORS.FINCH.BLACK} mb="2">
        Client User Authorization Form
      </Text>
      <Box mt="16px" borderRadius="12px" overflow="hidden" bg={COLORS.WHITE}>
        <iframe
          data-testid="isolved-pandadoc-iframe"
          title="iSolved PandaDoc form"
          src={PANDADOC_FORM_URL}
          style={{
            width: '100%',
            height: 'clamp(720px, calc(100vh - 220px), 1100px)',
            border: 0,
            display: 'block',
          }}
          onError={() => setDidFailToLoad(true)}
        />
      </Box>
      {didFailToLoad && (
        <Box mt="12px">
          <Text fontSize="13px" lineHeight="1.6" color={COLORS.FINCH.BLACK}>
            The embedded form could not be loaded here.{' '}
            <Link
              href={PANDADOC_FORM_URL}
              target="_blank"
              rel="noreferrer"
              fontWeight="600"
              textDecoration="underline"
            >
              Open the form in a new tab
            </Link>
            .
          </Text>
        </Box>
      )}
    </Box>
  );
};
